import React from 'react';
import './Hero.css';

function Hero() {
  return (
    <section id="hero" className="hero">
      <div className="hero-content">
        <div className="hero-image-container">
          <img 
            src="/jeff-lassiter.jpg" 
            alt="Jeff Lassiter" 
            className="hero-image"
          />
        </div>
        <h1 className="hero-title">Jeff Lassiter</h1>
        <h2 className="hero-role">AI Training & Evaluation Specialist</h2>
        <p className="hero-subtitle">
          Transform AI models with systematic evaluation, reasoning analysis, and actionable feedback. 
          Deploy evaluations in seconds. Achieve 99%+ accuracy. Improve model performance instantly.
        </p>
        <div className="hero-cta">
          <button 
            onClick={() => {
              const element = document.getElementById('portfolio');
              if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            }}
            className="cta-button"
          >
            Explore Portfolio →
          </button>
        </div>
      </div>
    </section>
  );
}

export default Hero;

